/* Encarts « adresse e-mail » : un clic copie l'adresse et ne fait rien d'autre
   (jamais de mailto, retour utilisateur du 2026-09-11). « Copié » s'affiche 2 s et
   est annoncé aux lecteurs d'écran. Si le navigateur refuse la copie, l'adresse est
   sélectionnée pour un Cmd/Ctrl + C.
   Utilisé par sections/contact-atelier.liquid ([data-copy-email]).
   Même logique que l'encart du bandeau revendeurs (assets/store-locator.js, [data-rv-copy]). */
(function () {
  if (window.__ezCopyEmail) return;
  window.__ezCopyEmail = true;

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(ta);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-copy-email]') : null;
    if (!btn) return;
    var mail = btn.getAttribute('data-copy-email');
    var status = btn.parentNode.querySelector('[data-copy-email-status]');
    copyText(mail).then(function () {
      btn.classList.add('is-copied');
      if (status) status.textContent = 'Adresse copiée';
      clearTimeout(btn._ezT);
      btn._ezT = setTimeout(function () { btn.classList.remove('is-copied'); if (status) status.textContent = ''; }, 2000);
    }, function () {
      var txt = btn.firstElementChild;
      if (txt && window.getSelection) {
        var range = document.createRange();
        range.selectNodeContents(txt);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
      if (status) status.textContent = 'Adresse sélectionnée, appuyez sur Cmd ou Ctrl + C pour la copier';
    });
  });
})();
